import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import AccountHolderDashboard from "@/components/project-dashboard/account-holder-main/account-holder-dashboard"
import AssignManager from "@/components/project-dashboard/account-holder-main/assign-manager"
import ViewManager from "@/components/project-dashboard/account-holder-main/view-manager"
import { urlPath } from "@/utils"

const AccountHolderMain = ({ userData }) => {
    const { user } = userData
    return (
        <Routes>
            <Route path="/view-manager" element={<ViewManager userCompanyId={user.companyId} userId={user.userId} />} />
            <Route path="/assign-manager" element={<AssignManager userCompanyId={user.companyId} userId={user.userId} />} />
            <Route path="/" element={<AccountHolderDashboard user={user} />} />
            <Route path="/*" element={<Navigate replace to={urlPath("account-holder-main", user.userId)} />} />
        </Routes>
    )
}

export default AccountHolderMain
